import React, { useState, useRef, useEffect } from 'react';
import { APIProvider, Map, Marker, useMap, AdvancedMarker, InfoWindow } from "@vis.gl/react-google-maps";
import axios from 'axios';
import PropTypes from 'prop-types';

function MapHandler({ onMapReady }) {
  const map = useMap(); // google.maps.Mapインスタンス取得
  useEffect(() => {
    if (map) {
      onMapReady(map); // マップ生成時に一度だけ呼ばれる
    }
  }, [map, onMapReady]);
  return null;
}

const SearchSpotMap = ({ spots: spotsData }) => {
  const [query, setQuery] = useState('');
  const [spots, setSpots] = useState([]);
  const [spotInfo, setSpotInfo] = useState(null);
  const [mapCenter, setMapCenter] = useState({ lat: 36.238, lng: 137.972 });
  const timeoutId = useRef(null);
  const spotMapRef = useRef(null);
  const spotMarkersRef = useRef([]);
  const [filteredSpots, setFilteredSpots] = useState(spotsData);

  function spotInfoContent(spot) {
    return (
      <a href={`/spot_maps/${spot.id}`} data-turbolinks="false">
        <div className="spot-info">
          <p>{spot.spot_name}</p>
          <div className="spot-info-details">
            <div>
              <p>{spot.spot_address}</p>
              <p>{spot.spot_status}</p>
            </div>
            <div className="spot-info-details-score">
              {spot.average_review_score
                ? Number(spot.average_review_score).toFixed(1)
                : 'No'}
            </div>
          </div>
        </div>
      </a>
    );
  }


  const filterSpots = (categoryId) => {
    if (!categoryId) {
    setFilteredSpots(spotsData); // 全スポット表示
    } else {
    setFilteredSpots(
    spotsData.filter(
    spot => spot.category_ids && spot.category_ids.some(id => id == categoryId)
    )
    );
    }
  };

  const handleCategoryClick = (category) => {
    let categoryId;
    
    switch (category) {
      case 'food':
        categoryId = "1";
        break;
      case 'photo':
        categoryId = "2";
        break;
      case 'sightseeing':
        categoryId = "3";
        break;
      case 'porsche':
        categoryId = "4";
        break;
      case 'all':
        categoryId = null;
        break;
      default:
        return;
    }
    
    filterSpots(categoryId);
  };

  const handleResetClick = async () => {
    // リセット処理
    window.location.reload();
  };

  const searchSpots = async (query) => {
    try {
      const response = await axios.get('/spot_maps/search', {
          params: {
              query
          }
      });

      if (Array.isArray(response.data)) {
        setSpots(response.data);
      } else {
        // setSpots([]); // Ensure spots is always an array
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleQueryChange = (e) => {
    const newQuery = e.target.value;
    setQuery(newQuery);
  
    // Clear the previous timeout if there is one
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
  
    // If the new query is not empty, search for spots
    if (newQuery) {
      // Set a new timeout
      timeoutId.current = setTimeout(() => searchSpots(newQuery), 700);
    } else {
      // If the new query is empty, clear the spots
      setSpots([]);
    }
  };

  // GoogleMapコンポーネントのonLoadで呼び出される関数
  function handleLoad(map) {
    // mapはGoogleMapインスタンス
    spotMapRef.current = map; // GoogleMapインスタンスをrefに保存

    // GoogleMapインスタンスが取得できた後の処理をここに書く
    initMapSpotMapExplore();
  }
  
  // Initial map loading
  // 非同期処理を行うため、関数にasyncをつける
  async function initMapSpotMapExplore() {
    // await google.maps.importLibrary('marker');
    
    if (spotsData && spotsData.length > 0) {
      spotsData.forEach(function(currentSpot) {
          // Check if lat and lng are not null
        if (currentSpot.spot_lat && currentSpot.spot_lng) {
            var position = {lat: currentSpot.spot_lat, 
              lng: currentSpot.spot_lng
          };
        }
      });
    }
  }

  useEffect(() => {
    initMapSpotMapExplore();
  }, []);

  useEffect(() => {
    // Remove existing markers from map
    spotMarkersRef.current.forEach((markerObject) => {
      markerObject.marker.setMap(null);
    });
    // Clear markers array
    spotMarkersRef.current = [];
  
    // Add new markers based on spots
    spots.forEach((currentSpot) => {
      // Check if lat and lng are not null
      if (currentSpot.spot_lat && currentSpot.spot_lng) {
        var position = {
          lat: currentSpot.spot_lat,
          lng: currentSpot.spot_lng,
        };
      }
    });
  }, [spots]); // Add spots as a dependency

  
  
  return (
    <div>
      <div className='spot-map-head'>
        <h2>スポット検索</h2>
      </div>
      
      <APIProvider>
        <Map 
          defaultCenter={mapCenter}
          Map defaultZoom={9}
          style={{ width: "100%", height: "266px" }}
          mapId={process.env.REACT_APP_GOOGLE_MAPS_ID}
        >
          <MapHandler onMapReady={handleLoad} />
          {filteredSpots
            .filter(spot => spot.spot_lat && spot.spot_lng)
            .map(spot => (
              <AdvancedMarker
                key={spot.id}
                position={{ lat: spot.spot_lat, lng: spot.spot_lng }}
                onClick={() => setSpotInfo(spotInfoContent(spot))}
              >
              </AdvancedMarker>
          ))}
        </Map>
      </APIProvider>
      <div className="spot-button-frame">
        <button type="button" className="spot-button orange food" onClick={() => handleCategoryClick('food')}>グルメ</button>
        <button type="button" className="spot-button green photo" onClick={() => handleCategoryClick('photo')}>写真</button>
        <button type="button" className="spot-button purple sightseeing" onClick={() => handleCategoryClick('sightseeing')}>観光</button>
        <button type="button" className="spot-button black porsche" onClick={() => handleCategoryClick('porsche')}>ポルシェ</button>
        <button type="button" className="spot-button blue all" onClick={() => handleCategoryClick('all')}>すべて</button>
        <button type="button" className="spot-button white reset" onClick={handleResetClick}>検索リセット</button>
      </div>
      {spotInfo && (
        <div className="spot-info-position">
          {spotInfo /* ここにJSXがそのまま表示される */}
        </div>
      )}

      <input type="text" className="spot-title spot-explore" id="search-field-id" value={query} onChange={handleQueryChange} placeholder="検索する（場所、キーワード）" />
      {/* 検索結果の表示 */}
      
      {spots.map((spot) => (
        <a href={`/spot_maps/${spot.id}`}>
          <div className="spot-info">
            <p>{spot.spot_name}</p>
            <div className="spot-info-details">
              <div>
                <p>{spot.spot_address}</p>
                <p>{spot.spot_status}</p>
              </div>
              <div className="spot-info-details-score">
              {spot.average_review_score ? parseFloat(spot.average_review_score).toFixed(1) : 'NO'}
              </div>
            </div>
          </div>
        </a>
      ))}
    </div>
  );
};
SearchSpotMap.propTypes = {
  spots: PropTypes.array,
};

export default SearchSpotMap;